import styles from './ResourceBtn.module.less'
import cls from 'classnames'
import { useTranslation } from 'react-i18next'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/DropdownMenu/DropdownMenu'
import { INTERNAL_HOST } from '@/commonConst'

function useOptions() {
  const { t } = useTranslation()
  const isInternal = INTERNAL_HOST.includes(location.hostname)
  const options = [
    {
      label: t('pageHeader.all'),
      value: 'all',
    },
    {
      label: t('pageHeader.news'),
      value: 'news',
    },
    {
      label: t('pageHeader.insight'),
      value: 'insight',
    },
    ...(!isInternal ? [
      {
        label: t('pageHeader.case'),
        value: 'case',
      },
    ] : []),
  ]
  return { OPTIONS: options }
}

interface Props {
  className: string
}

function ResourceBtn(props: Props) {
  const { OPTIONS } = useOptions()
  const { t, i18n } = useTranslation()

  const handleOptionClick = (value: string) => {
    const origin = location.origin
    if (value === 'all') {
      window.location.href = `${origin}/help/${i18n.language}/knowledge/all`
    } else if (value === 'news') {
      window.location.href = `${origin}/help/${i18n.language}/knowledge/news`
    } else if (value === 'insight') {
      window.location.href = `${origin}/help/${i18n.language}/knowledge/insight`
    } else if (value === 'case') {
      window.location.href = `${origin}/help/${i18n.language}/knowledge/case`
    }
  }

  return (
    <DropdownMenu openOnHover hoverCloseDelay={150}>
      <DropdownMenuTrigger className={cls(styles.triggerText, props.className)} data-testid='page-header-resource-btn'>
        {t('pageHeader.resourceCenter')}
      </DropdownMenuTrigger>
      <DropdownMenuContent align='center' className={styles.content}>
        {OPTIONS.map((option) => (
          <DropdownMenuItem
            key={option.value}
            className={styles.item}
            data-testid={`page-header-resource-option-${option.value}`}
            onSelect={() => handleOptionClick(option.value)}
          >
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default ResourceBtn
